import { mergeStyleSets } from '@fluentui/react';

var sharedClassNames = mergeStyleSets({
    iconButton: {
        height: '100%',
        padding: '0 12px',
        boxSizing: 'content-box'
    },
    link: {
        alignItems: 'center',
        display: 'flex',
        columnGap: 4,
        '&:hover': {
            textDecoration: 'none'
        },
        '&:active': {
            textDecoration: 'none'
        },
        '&:hover:active': {
            textDecoration: 'none'
        }
    }
});

export { sharedClassNames };
